<div class="fixed inset-0 z-[1060] flex min-h-screen items-center justify-center bg-slate-950/55 px-4 py-6"
  (keyup.enter)="onConfirm()">
  <div class="relative w-full max-w-[430px] rounded-2xl bg-white px-6 pb-6 pt-8 text-center shadow-2xl sm:px-7">
    @if (!data?.disableClose) {
    <button type="button" aria-label="Close" (click)="onCancel(null)"
      class="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full border-0 bg-slate-100 p-0 text-xl leading-none text-slate-500 transition hover:bg-slate-200 hover:text-slate-700">
      <i class="las la-times block leading-none"></i>
    </button>
    }

    @if (type == 'CONFIRM') {
    <div class="mx-auto mb-2 grid h-20 w-20 place-items-center rounded-full text-[42px]" [ngClass]="{
        'bg-red-100 text-red-600': modalAction === 'delete',
        'bg-orange-100 text-orange-600': modalAction === 'logout',
        'bg-sky-100 text-sky-600': modalAction === 'confirm'
      }">
      <i [class]="actionIcon"></i>
    </div>

    <h2 class="m-0 text-2xl font-bold leading-tight text-slate-900">
      {{ actionTitle }}
    </h2>

    <p class="mx-auto mt-3 max-w-[340px] text-[15px] leading-6 text-slate-500" [innerHTML]="actionMessage"></p>
    }

    @if (type == 'FORM') {
    <h2 class="mb-5 mt-0 text-2xl font-bold leading-tight text-slate-900">
      {{ data?.title || 'Confirm' }}
    </h2>
    }

    @if (data?.isFormField && formField.length) {
    <div class="mt-5 text-left">
      <app-form-generator #basicForm [dynamicValidator]="dynamicValidator || []" (onChangeEvent)="onChange($event)"
        [formData]="formField">
      </app-form-generator>
    </div>
    }

    @if (data?.info) {
    <p class="mt-4 text-sm text-sky-600">{{ data?.info }}</p>
    }

    <div class="mt-7 flex flex-col-reverse justify-center gap-2 sm:flex-row sm:flex-wrap">
      <button type="button" (click)="onCancel()"
        class="inline-flex h-10 w-full items-center justify-center whitespace-nowrap rounded-lg border-0 bg-slate-100 px-3 text-sm font-semibold leading-none text-slate-700 transition hover:bg-slate-50 sm:w-auto sm:min-w-[92px]">
        {{ cancelButtonText }}
      </button>

      @if (data?.btnDelete) {
      <button type="button" (click)="onDelete()"
        class="inline-flex h-10 w-full items-center justify-center whitespace-nowrap rounded-lg border-0 bg-red-600 px-3 text-sm font-semibold leading-none text-white transition hover:bg-red-700 sm:w-auto sm:min-w-[92px]">
        {{ data?.btnDelete }}
      </button>
      }

      <button type="button" [disabled]="data?.isFormField && isValid" (click)="onConfirm()"
        class="inline-flex h-10 w-full items-center justify-center whitespace-nowrap rounded-lg border-0 px-3 text-sm font-semibold leading-none text-white transition disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto sm:min-w-[92px]"
        [ngClass]="{
          'bg-red-600 hover:bg-red-700': modalAction === 'delete',
          'bg-orange-600 hover:bg-orange-700': modalAction === 'logout',
          'bg-teal-700 hover:bg-teal-800': modalAction === 'confirm'
        }">
        {{ confirmButtonText }}
      </button>
    </div>
  </div>
</div>
